// src/components/store/sections/blog-posts/BlogV24OrigamiribbonTealLagoon.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV24OrigamiribbonTealLagoon(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={24}
      archKey="origami_ribbon"
      archLabel="Origami Ribbon Articles"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      hexCol="#14b8a6"
      {...props}
    />
  );
}
